export function applySearchHandlers() {
    var runSearch = function () {
        var searchBox = document.getElementById('search-box');
        window.location.replace("/search/#".concat(searchBox.value));
    };
    var btn = document.getElementById('search-button');
    if (btn) {
        btn.addEventListener('click', runSearch);
    }
    var box = document.getElementById('search-box');
    if (box) {
        box.addEventListener('keydown', function (evt) {
            var code = (evt.keyCode ? evt.keyCode : evt.which);
            if (code == 13) {
                runSearch();
            }
        });
    }
}
